import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LanguageStore } from '../stores/LanguageStore';
import { en } from '../translations/en';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  private readonly _store = inject(LanguageStore);

  public loadLanguage(): Observable<void> {
    this._store.language.set({ code: 'en', name: 'English' });
    this._store.dictionary.set(en);
    return of(void 0);
  }
}
